import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    homepageWidgets: []
};

const getters = {
    getHomepageWidgets: (state) => state.homepageWidgets
};

const actions = {
    async getDocumentsStats( context ){
        return await axios.post(`${backendUrl()}/getDocumentsStats`, null,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getPortalUseStats( context ) {
        return await axios.post(`${backendUrl()}/getPortalUseStats`, null, 
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getBatchesStatusStats( context, data ) {
        return await axios.post(`${backendUrl()}/getBatchesStatusStats`, {durationInMonths: data.durationInMonths},
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getDocumentsPaymentsStats( context, data ) {
        return await axios.post(`${backendUrl()}/getDocumentsPaymentsStats`, null,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getDeliveryMethodsStats( context, data ) {
        return await axios.post(`${backendUrl()}/getDeliveryMethodsStats`, {durationInMonths: data.durationInMonths},
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getElectronicConversions( context, data ) {
        return await axios.post(`${backendUrl()}/getElectronicConversions`, {conversionsYear: data.conversionsYear},
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async saveWidget( context, data) {
        await axios.post(`${backendUrl()}/saveUserWidget`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        })
    },

    async removeWidget( context, data) {
        return await axios.post(`${backendUrl()}/removeWidget`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async loadWidget( context, data) {
        return await axios.post(`${backendUrl()}/loadUserWidget`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response
        })
    },

    async getAvailableWidgets( context, data ) {
        return await axios.post(`${backendUrl()}/getAvailableWidgets`, null, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response
        })
    },

    async getDocumentsStatusStats( context, data ) {
        return await axios.post(`${backendUrl()}/getDocumentsStatusStats`, { selectedYear: data.selectedYear },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },
    
    async getEmailStats( context, data ) {
        return await axios.post(`${backendUrl()}/getEmailStats`, { selectedYear: data.selectedYear },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getWidgetsPermissions( context, data) {
        return await axios.post(`${backendUrl()}/getWidgetsPermissions`, null,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async updateWidgetStatus( context, data) {
        await axios.post(`${backendUrl()}/updateWidgetStatus`, data,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            response.data
        })
    },

    async updateWidgetPermissions( context, data) {
        await axios.post(`${backendUrl()}/updateWidgetPermissions`, data,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },

    async createNewWidget( context, data ) {
        return await axios.post(`${backendUrl()}/createNewWidget`, 
        {
            widget: data,
            language: localStorage.getItem("currentTranslation")
        }, 
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    }
};

const mutations = {
    setHomepageWidgets:(state, widgets) => (state.homepageWidgets = widgets)
};

export default {
    namespaced: true,
  state,
  getters,
  actions,
  mutations
}


